export function safeStringify(obj: unknown, space: number = 2): string {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                console.log(`Circular reference detected at key: "${key}" in object:`, obj);
                return "[Circular]";
            }
            seen.add(value);
        }
        return value;
    }, space);
}
